import { useMutation } from "@tanstack/react-query";
import { uploadMultipleFiles } from "../../api";

/**
 * Hook để upload nhiều file
 * @returns Mutation object với hàm uploadFilesAsync và các state (isLoading, error, etc.)
 *
 * @example
 * const { uploadFilesAsync, isLoading } = useUploadFileMutation();
 *
 * const urls = await uploadFilesAsync([file1, file2]);
 * console.log("Upload thành công:", urls);
 */
export const useUploadFileMutation = () => {
  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: (files: File[]) => uploadMultipleFiles(files),
  });

  const uploadFilesMutation = (
    files: File[],
    options?: {
      onSuccess?: (data: string[]) => void;
      onError?: (error: Error) => void;
    },
  ) => {
    mutate(files, {
      onSuccess: (data) => {
        if (options?.onSuccess) options.onSuccess(data);
      },
      onError: (error) => {
        if (options?.onError) options.onError(error as Error);
      },
    });
  };

  return {
    uploadFiles: uploadFilesMutation,
    uploadFilesAsync: mutateAsync,
    ...rest,
  };
};
